const mediaItems = [
  {
    title: '2024 年度最受欢迎华语电影盘点',
    desc: '回顾过去一年备受好评的华语电影作品，从文艺片到商业大片全面解析观影趋势。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20award%20ceremony%20concept%20with%20warm%20golden%20spotlights%2C%20elegant%20red%20carpet%20atmosphere%2C%20movie%20poster%20style%20composition%2C%20rich%20crimson%20and%20amber%20tones%2C%20professional%20cinematography%20vibe%2C%20no%20people%2C%20glamorous%20lighting&width=1200&height=675&seq=media-chinese-film&orientation=landscape',
    views: '125.6万',
    duration: '15:32',
  },
  {
    title: '高分悬疑剧推荐：烧脑推理佳作合集',
    desc: '精选近年来口碑爆棚的悬疑推理类电视剧，剧情反转不断让你欲罢不能。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20office%20with%20warm%20dramatic%20lighting%2C%20investigation%20board%20with%20photos%2C%20noir%20film%20atmosphere%2C%20amber%20and%20deep%20brown%20tones%2C%20cinematic%20moody%20composition%2C%20elegant%20suspense%20aesthetic%2C%20rich%20warm%20shadows&width=1200&height=675&seq=media-suspense-tv&orientation=landscape',
    views: '98.3万',
    duration: '22:18',
  },
  {
    title: '国产动漫崛起之路：从追赶到引领',
    desc: '深入解读国产动漫近年来的飞速发展，从画风到剧情全面升级的创作力量。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20animation%20studio%20with%20warm%20creative%20lighting%2C%20digital%20drawing%20tablets%20and%20concept%20art%2C%20artistic%20workspace%2C%20golden%20amber%20and%20soft%20brown%20tones%2C%20cinematic%20composition%2C%20elegant%20creative%20atmosphere%2C%20no%20people&width=1200&height=675&seq=media-anime-rise&orientation=landscape',
    views: '86.7万',
    duration: '18:45',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            精彩视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精选影视解说与推荐内容，用视频方式快速了解值得看的好作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.title}
              className="group bg-white rounded-xl overflow-hidden border border-background-200/70 hover:shadow-md transition-all duration-300 cursor-pointer"
            >
              <div className="relative overflow-hidden h-48 md:h-52">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-primary-500/90 rounded-full group-hover:scale-110 transition-transform">
                  <i className="ri-play-fill text-white text-xl ml-0.5"></i>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/70 text-white text-xs px-2 py-1 rounded-md">
                  {item.duration}
                </div>
                <div className="absolute bottom-3 left-3 flex items-center gap-1 text-white text-xs bg-black/50 px-2 py-1 rounded-md">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}</span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}